"use client";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FC } from "react";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import MainLayout from "@/components/layout/mainLayout";
import { useState } from "react";

interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  areaCode: string;
  phone: string;
  companyname: string;
  registration: string;
  vatnumber: string;
  business: string;
  marketingConsent: Boolean;
}

const validationSchema = Yup.object({
  firstName: Yup.string().trim().required("First name is required"),
  lastName: Yup.string().trim().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  areaCode: Yup.string().required("Country code required"),
  phone: Yup.string()
    .required("Phone number required")
    .matches(/^[0-9 ]+$/, "Invalid phone number"),
  companyname: Yup.string().trim().required("Company name is required"),
  // vatnumber: Yup.string().required("Vat number is required"),
  business: Yup.string().trim().required("Nature of business is required"),
  // marketingConsent: Yup.boolean().oneOf([true], "You must accept this field"),
});

const initialValues: FormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  companyname: "",
  registration: "",
  vatnumber: "",
  business: "",
  areaCode: "+44",
  marketingConsent: false,
};

const Wholesale: FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (values: FormValues, { resetForm }: any) => {
    try {
      const payload = {
        company_name: values.companyname,
        company_registration_number: values.registration,
        company_vat_number: values.vatnumber,
        customer_contact_number: `${values.areaCode}${values.phone}`,
        customer_email: values.email,
        customer_first_name: values.firstName,
        customer_last_name: values.lastName,
        marketing_email_consent: values.marketingConsent ? "yes" : "no",
        nature_of_business: values.business,
        source: "DT",
      };

      const response = await fetch(
        "https://api.dtengg.com/api/v1/tse/b2b/register_customer",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (response.ok && data.status) {
        resetForm();
        setPopupMessage(data.message || "Success!");
        setIsError(false);
      } else {
        setPopupMessage(data.message || "Something went wrong!");
        resetForm();

        setIsError(true);
      }
      resetForm();
      setShowPopup(true);
    } catch (error) {
      setPopupMessage("Network error. Please try again.");
      setIsError(true);
      resetForm();

      setShowPopup(true);
    }
  };
  return (
    <MainLayout>
      <section className="wholesale-form-section">
        <div className="container py-5">
          <h1 className="text-center text-uppercase mb-4 heading-text">
            WHOLESALE
          </h1>

          <div className="form-container mx-auto">
            {/* Logo */}
            <div className="logo-wrapper text-center mb-4">
              <img src="/svg/logo.svg" alt="Duncan Taylor" />
            </div>

            {/* Header */}
            <div className="mb-4">
              <h2 className="form-title">Wholesale Application</h2>
              <p className="description">
                Thanks for your interest in carrying The Spirits Embassy
                wholesale! Please fill out the form below. You must have
                documented proof of business.
              </p>
            </div>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, values, isSubmitting, setFieldTouched }) => (
                <Form>
                  {/* Full Name */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Full Name<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <label className="sub-label">First Name</label>
                          <Field name="firstName" className="form-control" />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="error-msg"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="sub-label">Last Name</label>
                          <Field name="lastName" className="form-control" />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="error-msg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      E-mail<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <label className="sub-label">Work Email</label>
                      <Field
                        name="email"
                        type="email"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-msg"
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  {/* <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Phone Number<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <PhoneInput
                        country={"gb"}
                        enableSearch
                        value={`${values.areaCode}${values.phone}`}
                        containerClass="phone-container"
                        inputClass="form-control"
                        buttonClass="dropdown-btn"
                        onChange={(value, data: any) => {
                          setFieldValue(
                            "phone",
                            value.slice(data.dialCode.length),
                          );
                          setFieldValue("areaCode", `+${data.dialCode}`);
                        }}
                      />
                    </div>
                  </div> */}

                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Phone Number<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <PhoneInput
                        country={"gb"}
                        enableSearch
                        value={`${values.areaCode}${values.phone}`}
                        containerClass="phone-container"
                        inputClass="form-control"
                        buttonClass="dropdown-btn"
                        onChange={(value, data: any) => {
                          setFieldValue(
                            "phone",
                            value.slice(data.dialCode.length),
                          );
                          setFieldValue("areaCode", `+${data.dialCode}`);
                        }}
                        onBlur={() => setFieldTouched("phone", true)}
                      />

                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error-msg"
                      />
                    </div>
                  </div>

                  {/* Company Name */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Company Name<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <Field name="companyname" className="form-control" />
                      <ErrorMessage
                        name="companyname"
                        component="div"
                        className="error-msg"
                      />
                    </div>
                  </div>

                  {/* Registration */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Company Registration Number
                    </div>
                    <div className="col-md-8">
                      <Field name="registration" className="form-control" />
                      <ErrorMessage
                        name="registration"
                        component="div"
                        className="error-msg"
                      />
                    </div>
                  </div>

                  {/* VAT */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">VAT Number</div>
                    <div className="col-md-8">
                      <Field name="vatnumber" className="form-control" />
                      {/* <ErrorMessage
                        name="vatnumber"
                        component="div"
                        className="error-msg"
                      /> */}
                    </div>
                  </div>

                  {/* Business */}
                  <div className="row form-row">
                    <div className="col-md-4 label-col">
                      Nature of Business<span>*</span>
                    </div>
                    <div className="col-md-8">
                      <Field name="business" className="form-control" />
                      <ErrorMessage
                        name="business"
                        component="div"
                        className="error-msg"
                      />
                    </div>
                  </div>

                  <div className="row form-row align-items-start">
                    <div className="col-md-4"></div>

                    <div className="col-md-8">
                      <div className="form-check custom-checkbox">
                        <Field name="marketingConsent">
                          {({ field, form }: any) => (
                            <input
                              type="checkbox"
                              id="marketingConsent"
                              className="form-check-input"
                              checked={field.value}
                              onChange={() =>
                                form.setFieldValue(
                                  "marketingConsent",
                                  !field.value,
                                )
                              }
                            />
                          )}
                        </Field>

                        <label
                          className="form-check-label checkbox-text"
                          htmlFor="marketingConsent"
                        >
                          I agree to receive marketing emails from The Spirits
                          Embassy about exclusive offers, new products, and
                          promotions.
                        </label>
                      </div>

                      {/* <ErrorMessage
                        name="marketingConsent"
                        component="div"
                        className="error-msg"
                      /> */}
                    </div>
                  </div>

                  <div className="text-start mt-4">
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
            {showPopup && (
              <div
                className="success-popup"
                onClick={() => setShowPopup(false)}
              >
                <div
                  className="popup-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="close-btn"
                    onClick={() => setShowPopup(false)}
                  >
                    ✕
                  </button>

                  {/* <h2
                    className={`popup-title  ${isError ? "popup-titleerror" : "popup-titlesuccess"}`}
                  >
                    {isError
                      ? "Submission Failed"
                      : "Application Submitted Successfully!"}
                  </h2> */}

                  <p>{popupMessage}</p>

                  <p>For any immediate query,please contact us at:</p>
                  <p className="email">james.kidd@duncantaylor.com</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Wholesale;
